// Must match DELETION_GRACE_DAYS in meagenda-functions/functions/utils/addressDeletion.js
export const DELETION_GRACE_DAYS = 30;

// Key used by the profile tabs while the professional has no saved address yet.
// The placeholder has no id on purpose: nothing may be written under it.
export const PLACEHOLDER_ADDRESS_KEY = 'placeholder-address';

// Grace period elapsed: the document is a tombstone, its data is already gone.
export const isDeletedAddress = (address) => Boolean(
  address && (address.deletedAt || address.deletionCompleted),
);

// Removal was requested and can still be cancelled.
export const isPendingDeletion = (address) => Boolean(
  address && address.deletionRequestedAt,
) && !isDeletedAddress(address);

export const isActiveAddress = (address) => !isPendingDeletion(address) && !isDeletedAddress(address);

export const isPlaceholderAddress = (address) => Boolean(address && (address.isPlaceholder || !address.id));

export const addressTabKey = (address) => (address && address.id ? address.id : PLACEHOLDER_ADDRESS_KEY);
